import React, { useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  Box,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import { createQCReport } from "../../api/qcReports";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";
import dayjs from "dayjs";

const validationSchema = Yup.object().shape({
  workOrder: Yup.string().required("Orden de Trabajo es obligatoria"),
  operationDate: Yup.date().required("Fecha de Operación es obligatoria"),
  shift: Yup.string().required("Turno es obligatorio"),
  quantity: Yup.number().required("Cantidad es obligatoria").positive("Cantidad debe ser positiva"),
  inspectorName: Yup.string().required("Inspector es obligatorio"),
  observations: Yup.string(),
});

const initialValues = {
  workOrder: "",
  operationDate: dayjs().format("YYYY-MM-DD"),
  shift: "",
  quantity: "",
  inspectorName: "",
  observations: "",
};

export default function QCReportHeaderForm({ props }) {
  const { onSubmit, id ,data } = props;
  const companyId = data.companyId;
  const [loading, setLoading] = useState(false);
  const { openSnack } = useSnack();
  const [formData, setFormData] = useState(initialValues);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const payload = {
        ...values,
        finishedGoodId: id,
        companyId: companyId,
      };
      
      await createQCReport(payload);
      openSnack("Reporte creado exitosamente", "success");
      onSubmit();
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setLoading(false);
    }
  };

  return loading ? (
    <CircularProgress />
  ) : (
    <Formik
      enableReinitialize
      initialValues={formData}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        values,
        handleChange,
        handleBlur,
        errors,
        touched,
      }) => (
        <Form>
          <Box sx={{ p: 2 }}>
            <Grid container spacing={2}>
              {/* <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="batchNumber"
                  name="batchNumber"
                  label="Número de Lote"
                  value={values.batchNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.batchNumber && Boolean(errors.batchNumber)}
                  helperText={touched.batchNumber && errors.batchNumber}
                />
              </Grid> */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="workOrder"
                  name="workOrder"
                  label="Orden de Trabajo"
                  value={values.workOrder}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.workOrder && Boolean(errors.workOrder)}
                  helperText={touched.workOrder && errors.workOrder}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="operationDate"
                  name="operationDate"
                  label="Fecha de Operación"
                  type="date"
                  value={values.operationDate}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.operationDate && Boolean(errors.operationDate)}
                  helperText={touched.operationDate && errors.operationDate}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth error={touched.shift && Boolean(errors.shift)}>
                  <InputLabel id="shift-label">Turno</InputLabel>
                  <Select
                    labelId="shift-label"
                    id="shift"
                    name="shift"
                    value={values.shift}
                    label="Turno"
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <MenuItem value="MATUTINO">Matutino</MenuItem>
                    <MenuItem value="VESPERTINO">Vespertino</MenuItem>
                    <MenuItem value="MIXTO">Mixto</MenuItem>
                  </Select>
                  {touched.shift && errors.shift && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5, ml: 1.5 }}>
                      {errors.shift}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="quantity"
                  name="quantity"
                  label="Cantidad"
                  type="number"
                  value={values.quantity}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.quantity && Boolean(errors.quantity)}
                  helperText={touched.quantity && errors.quantity}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  id="inspectorName"
                  name="inspectorName"
                  label="Inspector"
                  value={values.inspectorName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.inspectorName && Boolean(errors.inspectorName)}
                  helperText={touched.inspectorName && errors.inspectorName}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  id="observations"
                  name="observations"
                  label="Observaciones"
                  value={values.observations}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.observations && Boolean(errors.observations)}
                  helperText={touched.observations && errors.observations}
                  multiline
                  rows={4}
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  fullWidth
                >
                  Crear Reporte
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Form>
      )}
    </Formik>
  );
}
